import { Result, Uuid } from '@standardnotes/domain-core';
export class ListRevisions {
    constructor(revisionManager) {
        this.revisionManager = revisionManager;
    }
    async execute(dto) {
        const itemUuidOrError = Uuid.create(dto.itemUuid);
        if (itemUuidOrError.isFailed()) {
            return Result.fail(`Could not list item revisions: ${itemUuidOrError.getError()}`);
        }
        const itemUuid = itemUuidOrError.getValue();
        try {
            const revisions = await this.revisionManager.listRevisions(itemUuid);
            return Result.ok(revisions);
        }
        catch (error) {
            return Result.fail(`Could not list item revisions: ${error.message}`);
        }
    }
}
